import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import { cn } from "@/lib/utils";
import { useRouter } from "next/router";
import CategoryLNB from "../lnb/CategoryLNB";
import { CategoryFloatingButton } from "./CategoryFloatingButton";
export const EditionCategoryPageLayout = (param)=>{
    let { children , lnbTitle , lnbTitleHref , lnbItems , selectedCategoryId , onCategorySelect , onDepthCategoryChange , categoryInfo , isLoading , onMobileCategoryDrawerOpen , isFirstDepth  } = param;
    const router = useRouter();
    // GNBSubNav 표시 여부에 따라 LNB top 위치 조정
    const isSubNavVisible = useScrollVisibility({
        mode: "direction"
    });
    // 무료체험 모듈 표시 여부
    // - isEligible이 false이면 비노출
    // - 단, isEligible이 false여도 reason이 "not_logged_in"이면 노출
    const freeTrialPromotion = categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.freeTrialPromotion;
    const showFreeTrialModule = (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.freeTrial) && freeTrialPromotion && (freeTrialPromotion.isEligible !== false || freeTrialPromotion.reason === "not_logged_in");
    const freeTrialModule = showFreeTrialModule ? {
        isUsed: freeTrialPromotion.remainingToday === 0,
        endTime: freeTrialPromotion.expiredAt,
        purchaseUrl: categoryInfo.purchaseUrl,
        onTimeUp: ()=>router.reload()
    } : undefined;
    return /*#__PURE__*/ _jsxs("div", {
        className: "min-h-screen bg-white",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mx-auto max-w-[1200px] px-5 sm:px-8 lg:px-0",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-6 lg:gap-12",
                    children: [
                        /*#__PURE__*/ _jsx("aside", {
                            className: "hidden shrink-0 md:block md:w-50 lg:w-60",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: cn("sticky transition-all duration-200", isSubNavVisible ? "top-[120px]" : "top-[72px]"),
                                children: /*#__PURE__*/ _jsx(CategoryLNB, {
                                    title: lnbTitle,
                                    titleHref: lnbTitleHref,
                                    items: lnbItems,
                                    selectedCategoryId: selectedCategoryId,
                                    onCategorySelect: onCategorySelect,
                                    freeTrialModule: freeTrialModule,
                                    onDepthCategoryChange: onDepthCategoryChange,
                                    isLoading: isLoading
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("main", {
                            className: "min-w-0 flex-1 pt-5 sm:pt-6",
                            children: children
                        })
                    ]
                })
            }),
            onMobileCategoryDrawerOpen && /*#__PURE__*/ _jsx(CategoryFloatingButton, {
                onClick: onMobileCategoryDrawerOpen
            })
        ]
    });
};
